import styled from '@emotion/styled'

import { Space } from '../../atoms'

export const StyledLinksContainer = styled(Space)`
  flex-wrap: wrap;
  height: 100px;
  background-color: var(--White97);
`

export const StyledDescriptionsContainer = styled(Space)`
  overflow-y: auto;
  max-height: 300px;
`
